import http from './http';

export default {
  all() {
    return http().get(`/v1/markets`);
  },
  get(id) {
    return http().get(`/v1/markets/${id}`);
  },
  create(data) {
    return http().post(`/v1/markets`, data);
  },
  update(data) {
    // This now needs to update the account data which will keep the market up to date for now.
  },
  delete(id) {
    return http().delete(`/v1/markets/${id}`);
  },
  getGoals(id) {
    return http().get(`/v1/markets/${id}/goals`);
  },
  patchGoals(data) {
    return http().patch(`/v1/markets/${data.marketId}/goals`, data);
  },
  setGoals(data) {
    return http().put(`/v1/markets/${data.marketId}/goals`, data);
  },
  setEmailIntegration(data)
  {
    return http().put(`/v1/markets/${data.market_id}/email_integration`, data);
  }
}
